// Shared product-search filter used by both the Catalog page and the header
// Search dropdown. Kept in one place so the two always match.
//
// Mirrors the original logic from Catalog.js verbatim so behavior doesn't
// change for existing users — just moves it where it can be reused.
export const filterFamilyLog = (familyLog, searchedValue, isSearchByPart, language) => {
  if (!searchedValue || !Array.isArray(familyLog) || familyLog.length === 0) {
    return [];
  }

  const searchArray = searchedValue
    .toLowerCase()
    .split(" ")
    .filter((element) => !!element);

  if (searchArray.length === 0) return [];

  const matches = familyLog.filter(
    (item) =>
      searchArray.every(
        (element) => item?.ZACP_DESHEB?.toLowerCase().includes(element) && !isSearchByPart
      ) ||
      searchArray.every(
        (element) =>
          item?.ZACP_DESENG?.toLowerCase().includes(element) &&
          language === "en" &&
          !isSearchByPart
      ) ||
      searchArray.every(
        (element) =>
          item?.ZACP_DESHEBD?.toLowerCase().includes(element) &&
          language === "he" &&
          !!isSearchByPart
      ) ||
      searchArray.every(
        (element) =>
          item?.ZACP_DESENGD?.toLowerCase().includes(element) &&
          language === "en" &&
          !!isSearchByPart
      ) ||
      searchArray.some((element) => item?.CUSTPARTNAME?.toLowerCase().includes(element)) ||
      searchArray.every((element) => item?.CUSTPARTDES?.toLowerCase().includes(element)) ||
      searchArray.some(
        (element) => item?.PARTNAME?.toLowerCase().includes(element) && !!isSearchByPart
      ) ||
      searchArray.some(
        (element) => item?.ZACP_MPARTNAME?.toLowerCase().includes(element) && !isSearchByPart
      )
  );

  if (!isSearchByPart) {
    const seen = new Set();
    return matches.filter((item) => {
      if (seen.has(item.ZACP_MPARTNAME)) return false;
      seen.add(item.ZACP_MPARTNAME);
      return true;
    });
  }

  return matches;
};
